export default "__VITE_ASSET__DxdOqNFG__"